import { useEffect, useRef } from 'react';

/**
 * Custom hook to auto-scroll to the bottom when dependencies change
 * @param {Array} dependencies - Array of dependencies to watch
 * @param {Object} options - Scroll behavior options
 */
export const useAutoScroll = (dependencies = [], options = {}) => {
  const scrollRef = useRef(null);
  const {
    behavior = 'smooth',
    delay = 0,
  } = options;

  useEffect(() => {
    const scrollToBottom = () => {
      if (!scrollRef.current) return;
      
      // Find the scrollable parent container (.chat-messages)
      const scrollContainer = scrollRef.current.closest('.chat-messages');
      
      if (scrollContainer) {
        // Scroll the container to bottom smoothly
        scrollContainer.scrollTo({
          top: scrollContainer.scrollHeight,
          behavior: behavior
        });
      }
    };

    if (delay > 0) {
      const timer = setTimeout(scrollToBottom, delay);
      return () => clearTimeout(timer);
    } else {
      scrollToBottom();
    }
  }, dependencies); // eslint-disable-line react-hooks/exhaustive-deps

  return scrollRef;
};
